// @flow

import axios from 'axios';
import { put, takeEvery } from 'redux-saga/effects';
import {
    SIGN_IN,
    REGISTER_GUEST,
    CHOSE_PROJECT
} from './../types/auth';
import {
    signInSuccess,
    signInFail,
    registerGuestSuccess,
    registerGuestFail,
    choseProjectSuccess,
    choseProjectFail
} from '../actions/auth';
import loading from './../utilities/loading';
import type { AuthAction } from './../types/auth';
import { getBaseUrl } from './../reducers/domainProperties';

const BASE_URL = getBaseUrl();

export function* signInSaga(action: AuthAction): Generator<any, void, any> {
    try {
        const { login, password, remember }: AuthAction = action;
        const { data } = yield axios.post(`${BASE_URL}account/sign-in`, { login, password });
        const { accessToken, passwordChanged, passwordToken } = data;
        if (accessToken) {
            const axiosInstance = axios.create({
                baseURL: BASE_URL,
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const userData = {
                login: login,
                remember: remember,
                passwordChanged: passwordChanged,
                passwordToken: passwordToken
            }
            loading.stop();
            yield put(signInSuccess(userData, axiosInstance, accessToken));
        } else {
            const { message } = data;
            loading.stop();
            yield put(signInFail(message));
        }
    } catch (error) {
        loading.stop();
        yield put(signInFail(error.response.data));
    }
}

export function* registerGuestSaga(action: AuthAction): Generator<any, void, any> {
    try {
        const { axiosInstance, userData, recaptchaResponse }: AuthAction = action;
        const { login, password, forename, surname, customerName, phoneNumber } = userData;
        yield axiosInstance.post(
            `${BASE_URL}account/register-guest`,
            {
                login: login,
                password: password,
                forename: forename,
                surname: surname,
                customerName: customerName,
                phoneNumber: phoneNumber,
                recaptchaResponse: recaptchaResponse,
                language: localStorage.getItem('language')
            })
        yield put(registerGuestSuccess(login));
    } catch (error) {
        yield put(registerGuestFail(error.response.data));
    }
};

export function* choseProjectSaga(action: AuthAction): Generator<any, void, any> {
    try {
        const { axiosInstance, project } = action;
        const response = yield axiosInstance.post(
            `${BASE_URL}account/choose-workspace`,
            {
                workspaceId: project.id,
                customerId: project.customerId,
            }
        )
        const accessTokenWithProj = response.data.accessToken;
        const axiosInstanceWithProj = axios.create({
            baseURL: BASE_URL,
            headers: {
                Authorization: `Bearer ${accessTokenWithProj}`
            }
        });
        loading.stop();
        yield put(choseProjectSuccess(project, axiosInstanceWithProj, accessTokenWithProj));
    } catch (error) {
        loading.stop();
        yield put(choseProjectFail(error.response.data));
    }
}

export function* watchSignIn(): Generator<any, void, any> {
    yield takeEvery(SIGN_IN, signInSaga);
};

export function* watchRegisterGuest(): Generator<any, void, any> {
    yield takeEvery(REGISTER_GUEST, registerGuestSaga);
}

export function* watchChoseProject(): Generator<any, void, any> {
    yield takeEvery(CHOSE_PROJECT, choseProjectSaga);
}


// WEBPACK FOOTER //
// ./src/sagas/auth.jsx